import * as React from 'react';
import { Col, Row, Container } from 'reactstrap';
import './Footer.css';

export class Footer extends React.Component<{},{}> {

  render() {
    return (
      <footer className="page-footer">
        <Container>
          <Row>
            <Col xs="12" sm="12" md="4">
              <p className="copy text-center text-md-left">
                <img src={require("../../assets/images/logo-green.png")} className="logo" alt="Kairo"/>
              </p>
            </Col>
            <Col xs="12" sm="12" md="8">
              <p className="copy text-center text-md-right">Kuusitie 14 A 27, 00270 Helsinki | <a href="/tietosuojaseloste">Tietosuojaseloste</a></p>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/footer/Footer.tsx